import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { BigNumber, PopulatedTransaction } from "ethers";
import { contractBaseQuery } from "./contract.base-query";
import { EApiSourceName, TContractAddress, TProject, TProjectProps, TTokenAddress } from "./types";

type TProjectId = string;
type TInvestmentId = string;
type TAmount = BigNumber;
type TRecipient = string;
type TFee = string;

const solutionContractApi = createApi({
  reducerPath: "solutionContractApi",
  baseQuery: contractBaseQuery,
  endpoints: (builder) => ({
    invest: builder.mutation<
      PopulatedTransaction,
      [TContractAddress, TInvestmentId, TProjectId, TTokenAddress, TAmount]
    >({
      query: ([contractAddress, ...args]) => ({
        contractAddress: contractAddress,
        contractName: EApiSourceName.SOLUTION,
        method: "invest",
        callData: args,
      }),
    }),
    createProject: builder.mutation<
      PopulatedTransaction,
      [TContractAddress, TProjectId, TProjectProps, TFee]
    >({
      query: ([contractAddress, ...args]) => ({
        contractAddress: contractAddress,
        contractName: EApiSourceName.SOLUTION,
        method: "createProject",
        callData: args,
      }),
    }),
    editProject: builder.mutation<
      PopulatedTransaction,
      [TContractAddress, TProjectId, TProjectProps]
    >({
      query: ([contractAddress, ...args]) => ({
        contractAddress: contractAddress,
        contractName: EApiSourceName.SOLUTION,
        method: "editProject",
        callData: args,
      }),
    }),
    withdraw: builder.mutation<
      PopulatedTransaction,
      [TContractAddress, TProjectId, TTokenAddress[], TRecipient]
    >({
      query: ([contractAddress, ...args]) => ({
        contractAddress: contractAddress,
        contractName: EApiSourceName.SOLUTION,
        method: "withdraw",
        callData: args,
      }),
    }),
    withdrawFee: builder.mutation<
      PopulatedTransaction,
      [TContractAddress, TTokenAddress[], TRecipient]
    >({
      query: ([contractAddress, ...args]) => ({
        contractAddress: contractAddress,
        contractName: EApiSourceName.SOLUTION,
        method: "withdrawFee",
        callData: args,
      }),
    }),
    projectById: builder.query<TProject, [TContractAddress, TProjectId]>({
      query: ([contractAddress, ...args]) => ({
        contractAddress,
        contractName: EApiSourceName.SOLUTION,
        method: "getProjectById",
        callData: args,
      }),
    }),
  }),
});

export const {
  useInvestMutation,
  useCreateProjectMutation,
  useProjectByIdQuery,
  useEditProjectMutation,
} = solutionContractApi;

export default solutionContractApi;
